module.exports = __webpack_public_path__ + "img/choose01.640170e9.png";